import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { BootstrapModuleFn as Bootstrap, hmr, WebpackModule } from '@ngxs/hmr-plugin';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { hmrBootstrap } from './hmr';

declare const module: WebpackModule;

if (environment.production) {
	enableProdMode();
}

// platformBrowserDynamic()
// 	.bootstrapModule(AppModule)
// 	.catch(err => console.log(err));

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  hmr(module, bootstrap).catch(err => console.error(err));
  // if (module['hot']) {
  //   hmrBootstrap(module, bootstrap);
  // } else {
  //   console.error('HMR is not enabled for webpack-dev-server!');
  //   console.log('Are you using the --hmr flag for ng serve?');
  // }
} else {
  bootstrap().catch(err => console.log(err));
}
